import { KeyValueProp } from '../../../base/interfaces/base'

/**
 * @description Tipo de articulo recursivo
 * @deprecated
 */
export interface TipoArticuloOperacionProp {
  codigo: string // Código del tipo de articulo, debe ser unico
  descripcion: string // Descripcion o agrupador del tipo de articulo
}

/**
 * Interfaz principal de los tipos de articulo
 * @deprecated
 */
export interface TipoArticuloProps {
  codigo: string
  descripcion: string
  grupoUnidadMedida: {
    codigoGrupo: number
    nombreGrupo: string
    unidadMedidaBase: {
      codigoUnidadMedida: string
      sinUnidadMedida: {
        codigoClasificador: number
        descripcion: string
      }
    }
  }
  notas: string[]
}

/**
 * @deprecated
 */
export interface TipoArticuloInputProps {
  codigo: string
  descripcion: string
  grupoUnidadMedida: string
  notas: KeyValueProp<string>[]
}

/**
 * @deprecated
 */
export interface TipoArticuloApiInputProps {
  descripcion: string
  notas: string[]
}

/**
 * @deprecated
 */
export const TIPO_ARTICULO_INITIAL_VALUES: TipoArticuloInputProps = {
  codigo: '',
  descripcion: '',
  grupoUnidadMedida: '',
  notas: [],
}
